import { IStringToString } from '../interfaces/core';
import { getApiUrl } from "../utils/apiUrl";

class TranslationApiService {

  getTranslations = async (languageCode: string): Promise<IStringToString> => {
    try {
      const response = await fetch(`${getApiUrl(process.env.REACT_APP_TRANSLATION_URL!)}/api/v1/Translations?applicationId=${process.env.REACT_APP_APPLICATION_ID}&isoCode=${languageCode}`);
      if (response.ok) {
        const responseData = await response.json();
        return responseData.data;
      }

      return {};
    } catch (e) {
      return {};
    }
  }

}

export const translationApiService = new TranslationApiService();
